import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import { useApi } from "../../../context/api.js";
import { closeCreateHomework, setHomework, useHomework } from "../../../context/homework";
import MDTypography from "../../../components/MDTypography";
import { formatDate } from "../../../utils/date.js";
import CreateHomework from "../../../components/CreateHomework";

function CreateHomeworkDialog() {
  const [homework, dispatch] = useHomework();
  const api = useApi();
  const [list, setList] = useState(null);
  const [h, setH] = useState(null);

  useEffect(() => {
    if (homework.createHomework) {
      if (homework.createHomework.list) {
        setList(null);
        api.getList(homework.createHomework.list).then((res) => {
          setList(res);
          setH({ list: { id: res.id }, validation: "individual" });
        });
      } else if (homework.createHomework.homework) {
        setList(null);
        api
          .getHomework(homework.createHomework.homework, homework.createHomework.from)
          .then((res) => {
            return api.getList(res.list.id).then((list) => {
              setList(list);
              setH(res);
            });
          });
      }
    }
  }, [homework.createHomework]);

  const isValid = () => {
    return h && h.name && !!h.type && !!h.category && !!h.validation;
  };

  const handleSave = () => {
    const toSave = {
      ...h,
      milestones: (h.milestones || []).map((m) => ({
        ...m,
        id: ("" + m.id).startsWith("tmp-") ? undefined : m.id,
      })),
    };
    api.saveHomework(toSave).then((res) => {
      if (res) {
        setHomework(dispatch, res, homework.createHomework.from, null);
        closeCreateHomework(dispatch);
      } else {
        // TODO : Display error
      }
    });
  };

  return (
    <Dialog
      open={!!homework.createHomework}
      onClose={() => closeCreateHomework(dispatch)}
      maxWidth="md"
      fullWidth
    >
      {list === null && (
        <DialogContent sx={{ textAlign: "center" }}>
          <CircularProgress color="info" />
        </DialogContent>
      )}
      {!!list && (
        <>
          {/*<DialogTitle>{h.name}</DialogTitle>*/}
          <DialogContent>
            {/*<DialogContentText>{h.description}</DialogContentText>*/}
            <MDTypography variant="h5" component="div">
              {h.id ? "Modification" : "Ajout"} d&apos;un devoir - {list.class.name}
            </MDTypography>
            <MDTypography
              sx={{
                mb: 1.5,
                fontStyle: "italic",
                fontSize: 12,
                color: new Date(list.end + "T23:59:59") <= new Date() ? "red" : undefined,
              }}
              color="text"
            >
              Devoirs à faire jusqu&apos;au {formatDate(list.end)}
            </MDTypography>
            <CreateHomework homework={h} onChange={setH} />
          </DialogContent>
          <DialogActions>
            <Button disabled={!list} onClick={() => closeCreateHomework(dispatch)}>
              Fermer
            </Button>
            <Button disabled={!list || !isValid()} color="info" onClick={handleSave}>
              Sauvegarder
            </Button>
          </DialogActions>
        </>
      )}
      <IconButton
        aria-label="close"
        onClick={() => closeCreateHomework(dispatch)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
}

export default CreateHomeworkDialog;
